<script setup>
import { computed } from 'vue';
import WheelsSection from './WheelsSection';

import { useMainStore } from '@/store/index.js';
const store = useMainStore();

const props = defineProps({
  items: {
    type: Object,
    default: null,
  },
  offerTemplate: {
    type: String,
    default: '',
    required: true,
  },
  specType: {
    type: String,
    default: '',
  },
  isFrameAgreement: {
    type: Boolean,
    default: false,
  },
  isBev: {
    type: Boolean,
    default: false,
  },
  isDW5: {
    type: Boolean,
    default: false,
  },
  isDW5V2: {
    type: Boolean,
    default: false,
  },
});

const isSpecEB = computed(() => {
  return props.offerTemplate === `${String(store.market).toUpperCase()}_STANDARDA4X2EB`;
});

const checkIfChassisSectionFrameAgreement = computed(() => {
  return props.isFrameAgreement;
});

const checkIfChassisSectionStockVehicle = computed(() => {
  return props.specType === 'stock_vehicle';
});

const checkIfChassisSectionStandard = computed(() => {
  return props.specType !== 'stock_vehicle' && !props.isBev && (!props.isDW5 && !props.isDW5V2);
});

const checkIfChassisSectionStandardBev = computed(() => {
  return props.isBev && (!props.isDW5 && !props.isDW5V2);
});

const checkIfChassisSectionDW5 = computed(() => {
  return props.isDW5 && !props.isBev;
});

const checkIfChassisSectionDW5V2 = computed(() => {
  return props.isDW5V2 && !props.isBev;
});
</script>

<template>
  <WheelsSection :items="props.items" />
</template>

<style scoped>
</style>
